import {
    InputLabel,
    MenuItem,
    ListSubheader,
    Select,
    FormControl,
    Checkbox,
    TextField,
    InputAdornment,
    ListItemText,
} from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import React, { useMemo } from "react";
import { CommandContextStore } from "../context/CommandContext";
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const LABELS = [
    'Recon',
    'Lateral',
    'PrivEsc',
    'Persistancy',
    'Exploitation',
    'Evasion',
    'Credential Access'
]
const POSSSESION = [
    'Creds',
    'Username',
    'Password',
    'No Creds',
    'Hash',
    'Ticket',
    'Shell'
]
const SERVICES = [
    'SMB',
    'WMI',
    'DCOM',
    'Kerberos',
    'RPC',
    'LDAP',
    'NTLM',
    'Registry',
    'Task Scheduler'
]
const OSS = [
    'Linux',
    'Windows',
    'Embedded'
]

const styles = {
    select: {
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#C3B490',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C3B490',
            borderWidth: '0.15rem',
        },
    },
};

const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

export const LabelsFilterSearch = () => {
    const commandContext = React.useContext(CommandContextStore);
    const [filter, setFilter] = React.useState([]);
    const [searchText, setSearchText] = React.useState("");

    const handleSelect = (event) => {
        const {
            target: { value }
        } = event;
        setFilter(value);
    }

    const renderMenuItems = (labels) => {
        if (labels !== undefined) {
            return labels.map(label => {
                return (
                    <MenuItem size="small" key={label} value={label} sx={{ padding: "0em" }}>
                        <Checkbox size="small" style={{ color: "#C3B490" }} checked={commandContext.labels.indexOf(label) > -1} />
                        <ListItemText primary={label} />
                    </MenuItem>
                )
            })
        }
    }

    React.useEffect(() => {
        commandContext.dispatch({ type: 'UPDATE_LABELS', data: filter });
    }, [filter])

    const labels = useMemo(() => {
        return LABELS.filter((option) => containsText(option, searchText))
    }, [searchText]);
    const possession = useMemo(() => {
        return POSSSESION.filter((option) => containsText(option, searchText))
    }, [searchText]);
    const services = useMemo(() => {
        return SERVICES.filter((option) => containsText(option, searchText))
    }, [searchText]);
    const oss = useMemo(
        () => OSS.filter((option) => containsText(option, searchText)),
        [searchText]
    );

    return (
        <>
            <FormControl sx={{ minWidth: 120, display: "flex" }} variant='outlined' >
                <InputLabel id="filterLabel" htmlFor="grouped-select" style={{ color: "#C3B490" }} >Attack Types</InputLabel>
                <Select
                    // defaultValue="" 
                    id="grouped-select"
                    label="Attack Types"
                    labelId="filterLabel"
                    multiple
                    value={commandContext.labels}
                    onChange={handleSelect}
                    onClose={() => setSearchText("")}
                    style={{ color: "white" }}
                    renderValue={() => filter.join(', ')}
                    sx={styles.select}
                    size='small'
                    startAdornment={
                        <InputAdornment position="start">
                            <FilterListIcon style={{ color: "#C3B490" }} />
                        </InputAdornment>
                    }
                    IconComponent={() => <ExpandMoreIcon style={{ color: "#C3B490", margin: '0.8vw' }} />}
                    MenuProps={{ PaperProps: { sx: { maxHeight: "70vh", width: "13vw" } } }} >

                    {/* Filters search */}
                    <ListSubheader>
                        <TextField
                            size="small"
                            // Autofocus on textfield
                            autoFocus
                            placeholder="Type to search..."
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation();
                                }
                            }}
                        />
                    </ListSubheader>

                    {/* Filter sections */}
                    <ListSubheader>Labels</ListSubheader>
                    {renderMenuItems(labels)}

                    <ListSubheader>Possesion</ListSubheader>
                    {renderMenuItems(possession)}

                    < ListSubheader > Services</ListSubheader>
                    {renderMenuItems(services)}

                    <ListSubheader>OSs</ListSubheader>
                    {renderMenuItems(oss)}


                </Select>
            </FormControl>
        </>
    )
}